import Award from './Award';
import Box from './Box';
import CaseStudy from './CaseStudy.model';
import ChartElement from './ChartElement';
import Comment from './Comment';
import Company from './Company';
import CompanyLogo from './CompanyLogo.model';
import Content from './Content.model';
import Country from './Country';
import Enterprise from './Enterprise';
import Event from './Event';
import File from './File';
import History from './History';
import JobOffer from './JobOffer';
import Link from './Link.model';
import Management from './Management.model';
import MissionAndVisionBigBox from './MissionAndVisionBigBox.model';
import News from './News.model';
import Office from './Office';
import Partner from './Partner.model';
import Person from './Person';
import Article from './Article.model';
import ArticleNews from './ArticleNews';
import Product from './Product.model';
import Panel from './Panel.model';
import Report from './Report';
import Report2 from './Report2';
import Report3 from './Report3';
import Shareholders from './Shareholders.model';
import RiskAndThreat from './RiskAndThreat';
import Service from './Service.model';
import SourceOfIncome from './SourceOfIncome';
import Specialization from './Specialization.model';
import SimpleCaseStudy from './SimpleCaseStudy.model';
import TeamOfExperts from './TeamOfExperts.model';
import TwoColumnsPanel from './TwoColumnsPanel.model';
import VideoComment from './VideoComment';
import FinancialResults from './FinancialResults.model';
import CompanyInfoBox from './CompanyInfoBox.model';
import SEO from './SEO.model';
import ForInvestors from './ForInvestors.model';
import ForInvestorsNews from './ForInvestorsNews.model';
import ForInvestorsUpcomingEvents from './ForInvestorsUpcomingEvents.model';
import ForInvestorsEvent from './ForInvestorsEvent.model';
import JobOfferLandingPage from './JobOfferLandingPage.model';
import JobOfferPageContent from './JobOfferPageContent';
import GlobalMetaTags from './GlobalMetaTags';
import GlobalMetaTag from './GlobalMetaTag';
import IssueOfShares from './IssueOfShares.model';
import Presentation from './Presentation.model';

export default {
  Article,
  ArticleNews,
  Award,
  Box,
  CaseStudy,
  ChartElement,
  Comment,
  Company,
  CompanyLogo,
  CompanyInfoBox,
  Content,
  Country,
  Enterprise,
  Event,
  File,
  History,
  JobOffer,
  Link,
  Management,
  MissionAndVisionBigBox,
  News,
  Office,
  Partner,
  Person,
  Product,
  Panel,
  Report,
  Report2,
  Report3,
  Shareholders,
  RiskAndThreat,
  Service,
  SourceOfIncome,
  Specialization,
  SimpleCaseStudy,
  VideoComment,
  TeamOfExperts,
  TwoColumnsPanel,
  SEO,
  ForInvestors,
  ForInvestorsNews,
  ForInvestorsUpcomingEvents,
  ForInvestorsEvent,
  JobOfferLandingPage,
  JobOfferPageContent,
  IssueOfShares,
  Presentation
};

export { Article };
export { ArticleNews };
export { Award };
export { Box };
export { CaseStudy };
export { ChartElement };
export { Comment };
export { Company };
export { CompanyLogo };
export { CompanyInfoBox };
export { Content };
export { Country };
export { Enterprise };
export { Event };
export { File };
export { History };
export { JobOffer };
export { Link };
export { Management };
export { MissionAndVisionBigBox };
export { News };
export { Office };
export { Partner };
export { Person };
export { Product };
export { Panel };
export { Report };
export { Report2 };
export { Report3 };
export { Shareholders };
export { RiskAndThreat };
export { Service };
export { SourceOfIncome };
export { Specialization };
export { SimpleCaseStudy };
export { VideoComment };
export { FinancialResults };
export { TeamOfExperts };
export { TwoColumnsPanel };
export { SEO };
export { ForInvestors };
export { ForInvestorsNews };
export { ForInvestorsUpcomingEvents };
export { ForInvestorsEvent };
export { JobOfferLandingPage };
export { JobOfferPageContent };
export { GlobalMetaTags };
export { GlobalMetaTag };
export { IssueOfShares };
export { Presentation };



// WEBPACK FOOTER //
// ./src/models/index.js